import formable from "@/mixins/formable";
import {
  GET_COMPANIES_SINGLE
} from "@/store/companies/actions";

import {
  GET_COMPANY_INVOICES_SERIAL_N
} from "@/store/company-invoices/actions";

import { mapState } from "vuex";
import VCompany from "@/components/widgets/VCompany";

export default {
  mixins: [
    formable
  ],
  components: {
    VCompany
  },
  data() {
    return {
      form: {
        details: [],
        payments: [],
        invoice_n: null,
        invoice_series: null,
        invoiceSeries: null,
        causal: "Abbonamento CiaoBooking",
        payment_data: {
          payment_term: null,
          payment_method: null,
          beneficiary: null,
          expires_at: null,
          amount: null,
          iban: null,
        },
      },
      totals: {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
      },
      seriesList: [
        "CB1",
        "CBE"
      ],
      seriesPrefix: this.$moment().format('YYYY'),
      invoiceSeries: null,
      currentCompany: {},
      paymentTerms: [
        {
          value: 'TP01',
          text: 'pagamento a rate',  
        },
        {
          value: 'TP02',
          text: 'pagamento completo',  
        },
        {
          value: 'TP03',
          text: 'anticipo',  
        },
      ],
      paymentMethods: [
        {
          value: 'MP05',
          text: 'Bonifico',
        },
        {
          value: 'MP08',
          text: 'Carta di pagamento',
        },
        {
          value: 'MP09',
          text: 'RID',
        },
      ]
    }
  },
  beforeMount() {
    if (this.companyId) {
      this.getCompany();
    }
  },
  methods: {
    getCompany() {
      this.$store.dispatch(GET_COMPANIES_SINGLE, {
        id: this.companyId,
        params: {
          _data: {
            relations: {
              vat_type: {
                selects: [
                  'id',
                  'value'
                ]
              }
            }
          }
        }
      });
    },
    addDetail() {
      this.form.details.push({
        vat_type: this.defaultVat
      });
    },
    removeDetail(index) {
      this.form.details.splice(index, 1);
    },
    getSerialNumber(options) {
      options = options || {};

      this.$store.dispatch(GET_COMPANY_INVOICES_SERIAL_N, options).then(response => {
        this.form.invoice_n = response ? response + 1 : 1;
      });
    },
    seriesChanged() {
      if (!this.invoiceSeries) {
        return;
      }

      this.getSerialNumber({
        invoice_series: `${this.seriesPrefix}${this.invoiceSeries}`
      })
    },
    calculateTotals() {
      this.totals = {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
      };

      this.form.details.map((detail) => {
        if (detail.amount !== 0 && !detail.amount) {
          return false;
        }

        const amount = parseFloat(detail.amount);
        const percent = parseInt(detail.vat_type || 0);

        let vatAmount = amount * percent / (percent + 100);
        vatAmount = vatAmount.toFixed(2);
        vatAmount = parseFloat(vatAmount);

        let netAmount = amount - vatAmount;
        netAmount = netAmount.toFixed(2);
        netAmount = parseFloat(netAmount);

        detail.amount = amount;
        detail.vat_amount = vatAmount;
        detail.net_amount = netAmount;

        this.totals.amount += detail.amount;
        this.totals.vat_amount += detail.vat_amount;
        this.totals.net_amount += detail.net_amount;
      });

      this.totals.amount = this.$money(this.totals.amount);
      this.totals.vat_amount = this.$money(this.totals.vat_amount);
      this.totals.net_amount = this.$money(this.totals.net_amount);
    },
    submitActionOptions() {
      let data = {
        ...this.form,
        ...this.totals
      };

      if (!data.details.length) {
        delete data['details'];
      }

      if (this.itemId) {
        return {
          id: this.itemId,
          params: data
        };
      }

      return data;
    },
    companyChanged(company) {
      this.currentCompany = company;

      if (company.id) {
        this.form.company_id = company.id;
      }
    }
  },
  computed: {
    initialized() {
      if (this.itemId) {
        return !this.itemRequest.loading;
      }

      return !this.vatTypesRequest.loading && !this.itemRequest.loading;
    },
    ...mapState({
      vatTypes: state => state.vatTypes.getListRequest.list,
      vatTypesRequest: state => state.vatTypes.getListRequest,
      itemRequest: state => state.quotes.getSingleRequest,
      companyRequest: state => state.companies.getSingleRequest,
    }),
    company() {
      return this.companyRequest.item;
    },
    defaultVat() {
      if (!this.company.vat_type) return 22;
      
      return this.company.vat_type.value;
    }
  },
  watch: {
    'form.details': {
      handler() {
        this.calculateTotals();
      },
      deep: true
    },
    invoiceSeries(val) {
      if (!val) {
        return;
      }
      this.form.invoice_series = `${this.seriesPrefix}${val}`;
    },
  }
};
